import { QuestionCircleFilled } from "@ant-design/icons"
import { Tooltip } from "antd"

const Title = (props) => {
  const { title, tipContent } = props

  return (
    <span>
      <span>{title}</span>
      <Tooltip
        // overlayInnerStyle={{ width: 300 }}
        // overlayStyle={{ width: 300 }}
        // autoAdjustOverflow={true}
        title={
          <div>
            {
              Array.isArray(tipContent) ?
                tipContent.map((item, key) => <p key={key}>{item}</p>) :
                <p>{tipContent}</p>
            }
          </div>
        }>
        <QuestionCircleFilled className="tips-icon" />
      </Tooltip>
    </span >
  )
}

export default Title
